export type FinanceSettingsType = {
    tfsSource: string; // Used for Texus GetFullConfiguration requests (availability service)
    financeAvailabilityService: string; // finance availability servcice endpoint
};

export const initialFinanceSettingsData: FinanceSettingsType = {
    tfsSource: "",
    financeAvailabilityService: "",
};

export type InsuranceSettingsType = {
    tisEnabled: boolean; // Used for Texus GetFullConfiguration requests (availability service)
    insuranceRate: string; // Link pointing to the insurance monthly rate service
    insuranceAvailabilityService: string; // Makolab insurance availability service endpoint
    insuranceRateDisclaimer: string; // Link pointing to the insurance rate legal text service
    insuranceModuleURL: string; // Link pointing to the AMD JavaScript file used for the insurance calculator
};

export const initialInsuranceSettingsData: InsuranceSettingsType = {
    tisEnabled: false,
    insuranceRate: "",
    insuranceAvailabilityService: "",
    insuranceRateDisclaimer: "",
    insuranceModuleURL: "",
};
